<template>
    <div class="configuration">
        <pulse-loader :loading="loading"></pulse-loader>
        <configuration-detail
            v-if="!loading"
            v-show="!isModalOpen"
            v-model="configuration"
            @input="updatePrice()"
            :editable="true"
        ></configuration-detail>
        <price-footer
            :configuration="configuration"
            v-show="!isModalOpen"
        ></price-footer>

        <modal-send-email
            v-if="sendingEmail"
            :configuration="configuration"
            :privacyLink="privacyLink"
            @close="onCloseModal()"
        ></modal-send-email>
        <modal-request-offer
            v-if="requestingOffer"
            :configuration="configuration"
            :privacyLink="privacyLink"
            @close="onCloseModal()"
        ></modal-request-offer>
    </div>
</template>

<style lang="scss" scoped>
.configuration {
    margin-bottom: 150px;
}
</style>

<script>
import BrandSelect from "./BrandSelect";
import CatalogModelList from "./CatalogModelList";
import ConfigurationDetail from "./ConfigurationDetail";
import PriceFooter from "./PriceFooter";
import ModalSendEmail from "./ModalSendEmail";
import ModalRequestOffer from "./ModalRequestOffer";

import CatalogModel from "../mixins/CatalogModel";

export default {
    components: {
        BrandSelect,
        CatalogModelList,
        ConfigurationDetail,
        PriceFooter,
        ModalSendEmail,
        ModalRequestOffer,
    },

    mixins: [CatalogModel],

    inject: ["locale"],

    data: function () {
        return {
            model: null,
            configuration: {
                model: null,
                engine: null,
                options: [],
                engine_price: 0,
                options_price: 0,
                price: 0,
            },
            sendingEmail: false,
            requestingOffer: false,
            loading: true,
            privacyLink: "",
        };
    },

    mounted: function () {
        this.getCatalogModel(this.$route.params.id, this.locale).then(
            (response) => {
                this.model = response.data;
                this.configuration.model = this.model;
                this.loading = false;
            }
        );

        this.$events.$on("request-offer", this.onOffer.bind(this));
        this.$events.$on("send-email", this.onEmail.bind(this));
    },

    computed: {
        isModalOpen() {
            return this.requestingOffer || this.sendingEmail;
        },
    },

    methods: {
        updatePrice() {
            let price = 0;
            if (this.configuration.engine) {
                price += this.configuration.engine.price;
            }
            this.configuration.engine_price = this.configuration.engine.price;

            this.configuration.options_price = 0;
            if (this.configuration.options.length) {
                let optionsPrice = 0;
                for (let option of this.configuration.options) {
                    optionsPrice += option.price;
                }
                this.configuration.options_price = optionsPrice;
                price += optionsPrice;
            }
            this.configuration.price = price;

            this.$events.$emit("configuration-changed", this.configuration);
        },
        onOffer() {
            this.requestingOffer = true;
        },
        onEmail() {
            this.sendingEmail = true;
        },
        onCloseModal() {
            this.requestingOffer = false;
            this.sendingEmail = false;
        },
    },
};
</script>
